import React from 'react';

import { Day } from '../types';
import moment from 'moment';
import {
  baseDateFormat,
  timeShiftDateFormat,
} from '../../../../../../common/helper';

type Props = {
  day: Day;
  style?: React.CSSProperties;
  label?: string;
  onClick?: VoidFunction;
};

export function CellWithoutTIme({ day, style, label, onClick }: Props) {
  return (
    <div className="time-shift-day" style={style} onClick={onClick}>
      <p className={`time-shift-day-text shift-code`} style={style}>
        {day?.code}
      </p>
      <p className={`time-shift-day-text`} style={style}>
        {moment().isSame(day?.date, 'day')
          ? 'Today'
          : baseDateFormat(day?.date, timeShiftDateFormat)}
        {day?.isSwapped && (
          <span className="time-shift-swapped">(Swapped)</span>
        )}
      </p>
      <p className={`time-shift-day-time`} style={style}>
        {label}
      </p>
    </div>
  );
}
